<template>
  <div class="interaction letter">
    <!-- 互动交流写信 -->
    <!-- 内容区 -->
    <div class="content inner">
      <!-- 面包屑导航 -->
      <div class="mbnav">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">
            <img class="homeIcon" src="/statics/image/index/home.png" alt />
            首页
          </el-breadcrumb-item>
          <el-breadcrumb-item>互动交流</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!-- 主任信箱 -->
      <div class="zrEmail">
        <div class="pic">
          <img class="homeIcon" src="/statics/image/index/xin.png" alt />
        </div>
        <div class="zr_con">
          <h3>不忘初心牢记使命两委班子＆个人征求意见留言专栏</h3>
          <p>该栏目面向全区各级党组织和基层党员群众征求意见。</p>
        </div>
      </div>
      <!-- 意见征求 -->
      <div class="opinion">
        <h3>意见征求</h3>
        <!-- 表 -->
        <div class="xin_table">
          <div class="one">
            <div class="lett_name">
              <span>姓名</span>
              <el-input v-model="name" placeholder="请输入您的姓名"></el-input>
            </div>
            <div class="lett_tel">
              <span>联系电话</span>
              <el-input v-model="tel" placeholder="请输入您的联系电话"></el-input>
            </div>
            <div class="lett_email">
              <span>电子邮箱</span>
              <el-input v-model="email" placeholder="请输入您的电子邮箱"></el-input>
            </div>
          </div>
          <div class="two">
            <span>留言主题</span>
            <el-input v-model="zhuti" placeholder="请输入您的主题"></el-input>
          </div>
          <div class="three">
            <span>留言</span>
            <el-input
              type="textarea"
              placeholder="请输入您的留言"
              v-model="textarea"
              maxlength="100"
              show-word-limit
            ></el-input>
          </div>
        </div>
        <!-- 按钮 -->
        <div class="xinbtn">
          <span class="chong" @click="toChong">重置</span>
          <span class="save" @click="toSave">保存</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: "", //姓名
      tel: "", //联系电话
      email: "", //电子邮箱
      zhuti: "", //留言主题
      textarea: "" //留言
    };
  },
  created() {
    this.toChong();
  },
  methods: {
    //   点击重置
    toChong() {
      this.name = "";
      this.tel = "";
      this.email = "";
      this.zhuti = "";
      this.textarea = "";
    },
    //   点击保存
    toSave() {
      // console.log(this.name, this.tel, this.email, this.zhuti, this.textarea);
      var that = this;
      const loading = this.$loading({
        lock: true,
        text: "",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.2)"
      });
      var ps = {
        user_name: that.name,
        title: that.zhuti,
        content: that.textarea,
        phone: that.tel,
        email: that.email
      };
      that.$api.index.postmsg(ps).then(function(res) {
        if (res.code == 200) {
          that.$message({
            message: res.msg,
            type: "success"
          });
          setTimeout(function() {
            that.$router.push({
              path: "/interaction",
              query: {
                index: that.$route.query.index
              }
            });
            loading.close();
          }, 2000);
        } else {
          loading.close();
        }
      });
    }
  },
  watch: {
    $route(to, from) {
      this.toChong();
    }
  }
};
</script>

<style>
</style>